"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var style_1 = require("./style");
var SlideButton_1 = __importDefault(require("./components/SlideButton"));
var UseSliding_1 = __importDefault(require("./components/UseSliding"));
var UseSizeElement_1 = __importDefault(require("./components/UseSizeElement"));
var context_1 = __importDefault(require("./context"));
var WReactResizeDetector = react_resize_detector_1.default;
var Slider = function (_a) {
    var padding = _a.padding, children = _a.children, isResponsive = _a.isResponsive;
    var _b = (0, react_1.useState)(), resolution = _b[0], setState = _b[1];
    var _c = (0, UseSizeElement_1.default)(resolution), width = _c.width, elementRef = _c.elementRef;
    var _d = (0, UseSliding_1.default)(width, react_1.default.Children.count(children)), handlePrev = _d.handlePrev, handleNext = _d.handleNext, slideProps = _d.slideProps, containerRef = _d.containerRef, hasNext = _d.hasNext, hasPrev = _d.hasPrev;
    var contextValue = {
        elementRef: elementRef
    };
    var onResize = function (width, height) {
        setState({ width: width, height: height });
    };
    return (react_1.default.createElement(WReactResizeDetector, __assign({ handleWidth: true }, { onResize: onResize }),
        react_1.default.createElement(context_1.default.Provider, { value: contextValue },
            react_1.default.createElement(style_1.SliderWrapper, { padding: padding },
                react_1.default.createElement("div", { className: "slider" },
                    react_1.default.createElement("div", __assign({ ref: containerRef, className: "slider__container" }, slideProps), children)),
                hasPrev && isResponsive && (react_1.default.createElement(SlideButton_1.default, { onClick: handlePrev, icon: react_1.default.createElement(core_1.Icon, { icon: "chevron-left" }), typeS: "prev" })),
                hasNext && isResponsive && (react_1.default.createElement(SlideButton_1.default, { onClick: handleNext, icon: react_1.default.createElement(core_1.Icon, { icon: "chevron-right" }), typeS: "next" }))))));
};
exports.default = Slider;
